import optimizelySDK from '@optimizely/optimizely-sdk'
import config from '@/config.js'

// The following variables are default values given in the library documentation
// https://docs.developers.optimizely.com/full-stack/docs/event-batching-javascript
const DEFAULT_MAX_SIZE_OF_EVENTS = 10
const ONE_SECOND_IN_MILLISECONDS = 1000
const FIVE_SECONDS_IN_MILLISECONDS = 5 * ONE_SECOND_IN_MILLISECONDS

const optimizelyInstance = optimizelySDK.createInstance({
  datafile: window.optimizelyDatafile,
  sdkKey: config.optimizelyKey,
  autoUpdate: true,
  eventBatchSize: DEFAULT_MAX_SIZE_OF_EVENTS,
  eventFlushInterval: ONE_SECOND_IN_MILLISECONDS,
  logLevel: 'warning',
})

function isFeatureEnabled(featureKey, userId = '', attributes = {}) {
  return optimizelyInstance.isFeatureEnabled(featureKey, userId, attributes)
}

function onReady() {
  return optimizelyInstance.onReady({
    timeout: FIVE_SECONDS_IN_MILLISECONDS,
  })
}

function getFeatureVariable(featureKey, variableKey, userId, attributes) {
  return optimizelyInstance.getFeatureVariable(
    featureKey,
    variableKey,
    userId,
    attributes
  )
}

function getAllFeatureVariables(featureKey, userId, attributes) {
  return optimizelyInstance.getAllFeatureVariables(
    featureKey,
    userId,
    attributes
  )
}

export default {
  isFeatureEnabled,
  getFeatureVariable,
  getAllFeatureVariables,
  onReady,
}
